import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderSlot as _renderSlot, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-73ba94b6")

_pushScopeId("data-v-73ba94b6")
const _hoisted_1 = { class: "file-selector" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "file-selector-wrapper" }
const _hoisted_5 = { class: "col1" }
const _hoisted_6 = { style: {"flex":"15"} }
const _hoisted_7 = { class: "selectedFileName" }
const _hoisted_8 = { class: "col2" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx, _cache) => {
  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("small", {
      class: (_ctx.isOversize || !_ctx.correctFileType ) ? 'error' : ''
    }, [
      (_ctx.isOversize)
        ? (_openBlock(), _createBlock("span", _hoisted_2, "Please choose a smaller file. "))
        : _createCommentVNode("", true),
      (!_ctx.correctFileType)
        ? (_openBlock(), _createBlock("span", _hoisted_3, "Please choose PDF file only"))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode("input", {
      type: "file",
      style: {"display":"none"},
      accept: ".pdf",
      ref: "fileSelector",
      name: 'file-input'+_ctx.id,
      id: 'file-input'+_ctx.id,
      onChange: _cache[1] || (_cache[1] = (...args) => (_ctx.onFileSelected && _ctx.onFileSelected(...args))),
      class: "file-upload-field"
    }, null, 40, ["name", "id"]),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _createVNode("div", {
            class: "filename-box disable-select",
            onClick: _cache[2] || (_cache[2] = _withModifiers((...args) => (_ctx.selectFile && _ctx.selectFile(...args)), ["prevent","stop"]))
          }, [
            _createVNode("span", _hoisted_7, _toDisplayString(_ctx.selectedFileName), 1)
          ])
        ])
      ]),
      _createVNode("div", _hoisted_8, [
        _createVNode("button", {
          class: "btn btn-secondary",
          onClick: _cache[3] || (_cache[3] = _withModifiers((...args) => (_ctx.selectFile && _ctx.selectFile(...args)), ["prevent","stop"])),
          disabled: _ctx.disabled
        }, _toDisplayString(_ctx.selectedFileName ? 'Change file' : 'Choose a file'), 9, ["disabled"]),
        _createVNode("div", null, [
          _renderSlot(_ctx.$slots, "uploadBtn", {}, undefined, true)
        ])
      ])
    ])
  ]))
})